// RUNTIME VALIDATOR - Ultimate backstop against price manipulation
// This runs continuous validation and blocks ANY price data storage

// Global flag to track if validation is active
(window as any).PRICE_MANIPULATION_BLOCKED = true;

// Function to completely validate localStorage state
function validateStorageState() {
    const cartData = localStorage.getItem('lillaflora_cart');
    
    if (cartData && cartData !== '[]') {
        try {
            const parsed = JSON.parse(cartData);
            
            if (Array.isArray(parsed)) {
                // Check each item for ANY non-allowed properties
                const hasInvalidData = parsed.some((item: any) => {
                    // Check for ANY property other than id and quantity
                    const allowedKeys = ['id', 'quantity'];
                    const itemKeys = Object.keys(item || {});
                    
                    // If ANY key exists that's not id or quantity, it's invalid
                    const hasInvalidKeys = itemKeys.some(key => !allowedKeys.includes(key));
                    
                    // Also check for specific manipulation fields
                    const hasManipulationFields = item.price !== undefined ||
                                                item.final_price !== undefined ||
                                                item.original_price !== undefined ||
                                                item.name !== undefined ||
                                                item.sku !== undefined ||
                                                item.categories !== undefined ||
                                                item.images !== undefined ||
                                                item.has_active_discount !== undefined;
                    
                    return hasInvalidKeys || hasManipulationFields;
                });
                
                if (hasInvalidData) {
                    console.error('🚨 RUNTIME VALIDATOR: MANIPULATION DETECTED - IMMEDIATE CLEANUP!');
                    console.error('📋 DETECTED DATA:', parsed);
                    
                    // Clean and save immediately
                    const cleaned = parsed
                        .filter((item: any) => item && typeof item.id === 'number' && typeof item.quantity === 'number')
                        .map((item: any) => ({ id: item.id, quantity: item.quantity }));
                    
                    localStorage.setItem('lillaflora_cart', JSON.stringify(cleaned));
                    
                    console.error('🔒 RUNTIME VALIDATOR: CLEANED TO:', cleaned);
                    
                    // Show user alert
                    if (typeof window !== 'undefined') {
                        alert('🛡️ SECURITY ALERT: Price manipulation attempt blocked by runtime validator!');
                    }
                    
                    return true; // Manipulation was found and cleaned
                }
            }
        } catch (error) {
            console.error('🚨 RUNTIME VALIDATOR: Error parsing cart data, clearing');
            localStorage.setItem('lillaflora_cart', '[]');
            return true;
        }
    }
    
    return false; // No manipulation found
}

// Ultra-aggressive validation - check every 50ms
const ULTRA_AGGRESSIVE_VALIDATOR = setInterval(() => {
    validateStorageState();
}, 50);

// Also validate on any DOM mutation (in case external scripts try to modify)
if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
        setTimeout(validateStorageState, 10);
    });

    const targetElement = document.body || document.documentElement;
    if (targetElement) {
        observer.observe(targetElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }
}

// Validate on any focus/blur events
window.addEventListener('focus', validateStorageState);
window.addEventListener('blur', validateStorageState);
window.addEventListener('beforeunload', validateStorageState);

// Validate on any storage events from other tabs
window.addEventListener('storage', (e) => {
    if (e.key === 'lillaflora_cart') {
        console.warn('🚨 RUNTIME VALIDATOR: Storage event detected from another tab');
        setTimeout(validateStorageState, 10);
    }
});

// Override Object.defineProperty to prevent cart key manipulation
const originalDefineProperty = Object.defineProperty;
Object.defineProperty = function(obj: any, prop: string | symbol, descriptor: PropertyDescriptor) {
    if (obj === localStorage && prop === 'lillaflora_cart') {
        console.error('🚨 RUNTIME VALIDATOR: Blocked attempt to redefine localStorage cart property');
        return obj; // Block the redefinition
    }
    return originalDefineProperty.call(this, obj, prop, descriptor);
};

// Initial validation
validateStorageState();

console.log('🛡️ RUNTIME VALIDATOR ACTIVE - Ultra-aggressive 50ms monitoring enabled');

export default {
    cleanup: () => clearInterval(ULTRA_AGGRESSIVE_VALIDATOR),
    validate: validateStorageState
};